<template>
  <div class="Order">
    <Header msg='订单详情' type='Order' v-if="!tid"/>
    <Header msg='订单详情' v-if="tid"/>

    <div v-if="!shownull">
        <div class="userOrder">
            <div class="per-line">
                <div class=" flex flex-j-c-sb">
                    <span>基本信息</span>
                    <div></div>
                </div>
            </div>
            <div class="orderBox flex flex-j-c-sb flex-a-i-center" v-if="pageData.basic_info">
                <div class="order-msg flex flex-j-c-sb ellipsis">
                    <p><span>姓名：</span><span>{{pageData.basic_info.true_name || '-'}}</span></p>
                    <p><span>性别：</span><span>{{pageData.basic_info.sex || '-'}}</span></p>
                    <p><span>手机号：</span><span>{{pageData.basic_info.mobile || '-'}}</span></p>
                    <p><span>证件号：</span><span>{{pageData.basic_info.idcard || '-'}}</span></p>
                </div>
                <img :src="pageData.basic_info.avatar_url" class="order-avatar"/>
            </div>
        </div>
        <div class="OrderMessage">
            <div class="per-line">
                <div class=" flex flex-j-c-sb">
                    <span>报读信息</span>
                    <div class="flex flex-j-c-e method-right" @click="toProcess">
                        <p class="text-yellow">报读流程</p>
                        <img class="right-icon" src="@/assets/icon_go_Y@3x.png">
                    </div>
                </div>
            </div>
            <div class="orderBox" v-if="pageData.enroll">
                <div class="per-line">
                    <div class=" flex flex-j-c-sb">
                        <span>{{pageData.enroll.header || '-'}}</span>
                        <div></div>
                    </div>
                </div>
                <div class="order-msg flex flex-j-c-sb ellipsis">
                    <p><span>专业：</span><span>{{pageData.enroll.major || '-'}}</span></p>
                    <p><span>学号：</span><span>{{pageData.basic_info.student_no || '-'}}</span></p>
                    <p><span>学习形式：</span><span>{{pageData.enroll.learning_modality || '函授'}}(业余)</span></p>
                    <p><span>我的状态：</span><span>{{pageData.enroll.statusStr || '-'}}</span></p>
                    <p><span>报读类型：</span><span>{{pageData.enroll.enrolment_name || '-'}}</span></p>
                    <p><span>备注：</span><span>{{pageData.enroll.remark || '-'}}</span></p>
                </div>
            </div>
        </div>

        <div class="orderFunc" v-if="pageData.footer.ccaa">
            <!-- ------------------------------------------------------------------------------------------------- -->
            <div class="per-line" :style="judge[0] ? 'border-bottom:1px solid #eeeeee':'border:none'">
                <div class=" flex flex-j-c-sb flex-a-i-center" @click="changeJudge(0)">
                    <span>考前辅导</span>
                    <div class="flex flex-j-c-e method-right flex-a-i-center">
                        <img class="right-icon" src="@/assets/right.png" :class="judge[0] ? 'rightActive':''"/>
                    </div>
                </div>
            </div>
            <div class="orderBox" :class="judge[0] ? 'orderBoxShow':''" v-if="pageData.footer.ccaa">
                <div class="order-msg flex flex-j-c-sb">
                    <p><span>时间：</span><span>{{pageData.footer.ccaa.time}}</span></p>
                    <p><span>课程：</span><span>{{pageData.footer.ccaa.course}}</span></p>
                    <p><span>金额：</span><span>{{pageData.footer.ccaa.total_price}}</span></p>
                    <p><span>订单号：</span><span>{{pageData.footer.ccaa.order_no}}</span></p>
                    <p><span>服务老师：</span><span>{{pageData.footer.ccaa.teacher_name}}</span></p>
                    <p v-if="pageData.footer.ccaa.express"><span>物流公司：</span><span>{{pageData.footer.ccaa.express}}</span></p>
                    <p v-if="pageData.footer.ccaa.express_no" class="flex"><span>快递单号：</span><span>{{pageData.footer.ccaa.express_no}}<i class="textcopy" @click="copyChannel(pageData.footer.ccaa.express_no)">复制</i></span></p>
                </div>
                <div class="tagsBox flex flex-j-c-sb" v-if="!tid">
                    <div class="flex">
                        <p class="orderFunc-tips orderFunc-tipsn" v-show="pageData.footer.ccaa.issue_str">#{{pageData.footer.ccaa.issue_str}}</p>
                        <p class="orderFunc-tips" v-show="pageData.footer.ccaa.pay_str">#{{pageData.footer.ccaa.pay_str}}</p>
                    </div>
                    <p class="orderFunc-btn" :style="{'background-image': 'url('+ orderbtn +')'}" v-if="pageData.footer.ccaa.is_pay === 0" @click="payBtn(pageData.footer.ccaa.order_no, 0)">我要缴费</p>
                    <p class="orderFunc-btn" :style="{'background-image': 'url('+ orderbtn +')'}" @click="showRe(pageData.footer.ccaa)" v-else>查看收据</p>
                </div>
            </div>
            <!-- ------------------------------------------------------------------------------------------------- -->
            <div class="per-line" v-if="pageData.footer.ccaa.is_pay !== 0" style="display:none">
                <div class=" flex flex-j-c-sb flex-a-i-center" @click="changeJudge(1)">
                    <span>第一年学费</span>
                    <div class="flex flex-j-c-e method-right flex-a-i-center">
                        <img class="right-icon" src="@/assets/right.png" :class="judge[1] ? 'rightActive':''"/>
                    </div>
                </div>
            </div>
            <div class="orderBox" :class="judge[1] ? 'orderBoxShow':''" v-if="pageData.footer.first_year">
                <div class="order-msg flex flex-j-c-sb">
                    <p><span>金额：</span><span>{{pageData.footer.first_year.first_total_price}}</span></p>
                    <p><span>订单号：</span><span>{{pageData.footer.first_year.order_no}}</span></p>
                </div>
                <div class="tagsBox flex flex-j-c-sb" v-if="!tid">
                    <div class="flex">
                        <p class="orderFunc-tips orderFunc-tipsn" v-show="pageData.footer.first_year.issue_str">#{{pageData.footer.first_year.issue_str}}</p>
                        <p class="orderFunc-tips" v-show="pageData.footer.first_year.pay_str">#{{pageData.footer.first_year.pay_str}}</p>
                    </div>
                    <p class="orderFunc-btn" :style="{'background-image': 'url('+ orderbtn +')'}" v-if="pageData.footer.first_year.is_pay === 0" @click="payBtn(pageData.footer.first_year.order_no, 1)">我要缴费</p>
                    <p class="orderFunc-btn" :style="{'background-image': 'url('+ orderbtn +')'}" @click="showRe(pageData.footer.first_year)" v-else>查看收据</p>
                </div>
            </div>
            <!-- ------------------------------------------------------------------------------------------------- -->
            <div class="per-line" v-if="pageData.footer.first_year.is_pay !== 0" style="display:none">
                <div class=" flex flex-j-c-sb flex-a-i-center" @click="changeJudge(2)">
                    <span>第二年学费</span>
                    <div class="flex flex-j-c-e method-right flex-a-i-center">
                        <img class="right-icon" src="@/assets/right.png" :class="judge[2] ? 'rightActive':''"/>
                    </div>
                </div>
            </div>
            <div class="orderBox" :class="judge[2] ? 'orderBoxShow':''" v-if="pageData.footer.second_year">
                <div class="order-msg flex flex-j-c-sb">
                    <p><span>金额：</span><span>{{pageData.footer.second_year.second_total_price}}</span></p>
                    <p><span>订单号：</span><span>{{pageData.footer.second_year.order_no}}</span></p>
                </div>
                <div class="tagsBox flex flex-j-c-sb" v-if="!tid">
                    <div class="flex">
                        <p class="orderFunc-tips orderFunc-tipsn" v-show="pageData.footer.second_year.issue_str">#{{pageData.footer.second_year.issue_str}}</p>
                        <p class="orderFunc-tips" v-show="pageData.footer.second_year.pay_str">#{{pageData.footer.second_year.pay_str}}</p>
                    </div>
                    <p class="orderFunc-btn" :style="{'background-image': 'url('+ orderbtn +')'}" v-if="pageData.footer.second_year.is_pay === 0" @click="payBtn(pageData.footer.second_year.order_no, 2)">我要缴费</p>
                    <p class="orderFunc-btn" :style="{'background-image': 'url('+ orderbtn +')'}" @click="showRe(pageData.footer.second_year)" v-else>查看收据</p>
                </div>
            </div>
            <!-- ------------------------------------------------------------------------------------------------- -->
            <div class="per-line" style="display:none" :style="judge[3] ? 'border-bottom:1px solid #eeeeee':'border:none'" v-if="pageData.footer.second_year.is_pay !== 0">
                <div class=" flex flex-j-c-sb flex-a-i-center" @click="changeJudge(3)">
                    <span>第三年学费</span>
                    <div class="flex flex-j-c-e method-right flex-a-i-center">
                        <img class="right-icon" src="@/assets/right.png" :class="judge[3] ? 'rightActive':''"/>
                    </div>
                </div>
            </div>
            <div class="orderBox" :class="judge[3] ? 'orderBoxShow':''" v-if="pageData.footer.third_year">
                <div class="order-msg flex flex-j-c-sb">
                    <p><span>金额：</span><span>{{pageData.footer.third_year.third_total_price}}</span></p>
                    <p><span>订单号：</span><span>{{pageData.footer.third_year.order_no}}</span></p>
                </div>
                <div class="tagsBox flex flex-j-c-sb" v-if="!tid">
                    <div class="flex">
                        <p class="orderFunc-tips orderFunc-tipsn" v-show="pageData.footer.third_year.issue_str">#{{pageData.footer.third_year.issue_str}}</p>
                        <p class="orderFunc-tips" v-show="pageData.footer.third_year.pay_str">#{{pageData.footer.third_year.pay_str}}</p>
                    </div>
                    <p class="orderFunc-btn" :style="{'background-image': 'url('+ orderbtn +')'}" v-if="pageData.footer.third_year.is_pay === 0" @click="payBtn(pageData.footer.third_year.order_no, 3)">我要缴费</p>
                    <p class="orderFunc-btn" :style="{'background-image': 'url('+ orderbtn +')'}" @click="showRe(pageData.footer.third_year)" v-else>查看收据</p>
                </div>
            </div>
            <!-- ------------------------------------------------------------------------------------------------- -->
        </div>
    </div>

    <!-- 收据 -->
    <!-- <div class="mask" @touchmove.prevent :class="!showReceipt ? 'Enrolment-Hide':'Enrolment-Show'">
        <img src="@/assets/comm/receipt.png" class="Receipts" />
        <img src="@/assets/home/Receive_icon_close@3x.png" class="Receipts-close" @click="showReceipt = false" />
    </div> -->

    <DataNull v-if="shownull"/>

    <div @touchmove.prevent class="mask" :class="!showReceipt ? 'Enrolment-Hide':'Enrolment-Show'" @click="showReceipt = false">
        <div class="Receipt-box">
            <h4>陈文卫教育报班回执</h4>
            <div class="Receipt-msg flex flex-j-c-sa">
                <p style="text-align: left;">订单编号：{{receiptData.no  || '-'}}</p>
                <p class="flex flex-j-c-sb">
                    <span class="ellipsis">姓名：{{pageData.basic_info.true_name || '-'}}</span>
                    <span class="ellipsis">电话：{{pageData.basic_info.mobile || '-'}}</span>
                </p>
                <!-- <p class="flex flex-j-c-sa">
                    <span class="ellipsis" style="max-width:60%"></span>
                </p> -->
            </div>
            <table border="1" borderColor="#eee" >
                <tr style="color:#999">
                    <td>缴费项目</td>
                    <td>班别</td>
                </tr>
                <tr>
                    <td>{{pageData.enroll.major || '-'}}</td>
                    <td>{{pageData.enroll.header || '-'}}</td>
                </tr>
            </table>
            <table border="1" borderColor="#eee">
                <tr>
                    <td rowspan="2">收费统计</td>
                    <td style="color:#999">支付方式</td>
                    <td style="color:#999">已缴合计</td>
                </tr>
                <tr>
                    <td>微信</td>
                    <td>{{receiptData.price  || '-'}}</td>
                </tr>
                <tr>
                    <td colspan="3" style="text-align: right;padding-right:0.1rem;">报名时间：{{receiptData.date || '---'}}</td>
                </tr>
            </table>
            <div class="Confirmation-tips flex flex-j-i-center">
                <p>备注：</p>                
                <p>1、请保持好此单，作为缴费、开学、领教材凭证；</p>
                <p>2、此单作为缴费凭证，请于缴齐学费2月份内到前台登记开票（凭此单）；</p>
                <p>3、从报名之日起，超一年补差额。</p>
            </div>
        </div>
        <!-- <img src="@/assets/home/Receive_icon_close@3x.png" class="Receipts-close" @click="showReceipt = false" /> -->
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import DataNull from '@/components/DataNull';
import {getOrderMsg} from '@/api';
import { MessageBox, Toast } from 'mint-ui';
import copy from 'copy-to-clipboard';

export default {
  name: 'Order',
  components: {
    Header,
    DataNull
  },
  data() {
    return {
      judge: [true, false, false, false], // 订单是否展开判断更改
      orderbtn: require('@/assets/mine/Order_btn_s@3x.png'), // 按钮背景
      showReceipt: false, // 是否显示回执
      pageData: {
        basic_info: {},
        enroll: {},
        footer: {}
      }, // 页面数据
      shownull: false,
      sessionData: {}, // 临时数据 缓存
      receiptData: {}, // 回执数据
      tid: '' // 教师预报名订单ID
    }
  },
  created() {
    this.tid = this.$route.query.tId || '';
    this.getOrder();
    this.sessionData = JSON.parse(sessionStorage.getItem('_sessionData'));
    if (this.sessionData && this.sessionData.Order) this.pageData = JSON.parse(this.sessionData.Order);
  },
  mounted () {
  },
  methods: {
    // 报读流程
    toProcess() {
      this.$router.push({name:'Process'})
    },
    // 获取订单信息
    getOrder() {
      let idData = {};
      if (this.tid) {
        idData = {query_user_id: this.tid};
      }
      getOrderMsg(idData).then(res => {
        if (res.code !== 0) { this.shownull = true; }
        if (!this._tools.checkSData(res.data, 'Order')) {
          this.pageData = res.data;
		  
        }
        window.scrollTo(0, 0)
      })
    },
    // 订单是否展开判断更改
    changeJudge(e) {
      let newjudge = !this.judge[e]
      this.judge.splice(e, 1, newjudge);
    },
    /**
     * 缴费
     * no 订单号
     * index 索引
     */
    payBtn(no, index) {
      // this.$store.commit('changeNo', no);
      sessionStorage.removeItem("_couponPay");
      let keys = '';
      switch (index) {
        case 0:
          keys = 'k'
          break;
        case 1:
          keys = 'fr'
          break;
        case 2:
          keys = 'se'
          break;
        case 3:
          keys = 'th'
          break;
        default:
          break;
      }
      let params = {order_no: no, key: keys}
      sessionStorage.setItem('_needpayOrderNo', JSON.stringify(params));
      this.$router.push({name:'Pay'})
    },
    // 查看收据
    showRe(e) {
		console.log(e)
      this.receiptData = {
        no: e.order_no,
        // date: e.time.slice(0, 11),
        date: this.pageData.enroll.pay_time,
        price: e.total_price
      }
      this.showReceipt = true;
    //   MessageBox('提示', '工作人员暂未上传收据！');
    },
    // 复制
    copyChannel(e) {
      copy(e);
      Toast({message: '订单号已复制', duration: 1500});
    }
  },
  watch: {
  }
};
</script>

<style lang="less" scoped>
  .Order{
    min-height: 100vh;
    font-size: 0.15rem;
    .orderBox{
        background: white;
        padding: 0.16rem;
        margin: 0 -0.16rem;
        .order-msg{
            flex-direction: column;
            text-align: left;
            width: 75%;
            line-height: 0.25rem;
            P{
                span{
                    display: inline-block;
                    width: 75%;
                }
                span:first-child{
                    width: 25%;
                    vertical-align: top;
                }
            }
        }
        .order-avatar{
            width: 0.75rem;
            height: 1rem;
        }
    }
    .userOrder{
        margin-top: 0.44rem;
        padding: 0 0.16rem;
        color: #666666;
        font-size: 0.14rem;
        .per-line{
            line-height: 0.6rem;
        }
        &>div{
            border: none;
        }
        .orderBox{
            background: white;
            padding: 0.16rem;
            margin: 0 -0.16rem;
            .order-msg{
                flex-direction: column;
                text-align: left;
                width: 75%;
                line-height: 0.25rem;
                P{
                    span:first-child{
                        display: inline-block;
                        width: 25%;
                    }
                }
            }
            .order-avatar{
                width: 0.75rem;
                height: 1rem;
            }
        }
    }
    .OrderMessage{
        padding: 0 0.16rem;
        color: #666666;
        font-size: 0.14rem;
        .right-icon{
            width: 0.07rem;
            height: 0.12rem;
        }
        &>.per-line{
            height: 0.45rem;
            line-height: 0.5rem;
            border: none;
        }
        .orderBox{
            padding: 0 0.16rem 0.16rem;
            .order-msg{
                width: 100%;
                line-height: 0.25rem;
                margin-top: 0.1rem;
            }
        }
    }
    .orderFunc{
        background: white;
        margin: 0.1rem 0 0;
        border-bottom: 0.5rem solid #F6F6FA;
        padding: 0 0.16rem;
        div:last-child{
            border: none;
        }
        .orderBox{
            display: none;
            padding: 0 0.16rem 0.16rem;
            .order-msg{
                width: 100%;
                line-height: 0.25rem;
                margin-top: 0.1rem;
            }
        }
        .orderBoxShow{
            display: block;
            -webkit-animation: navShow 0.3s;
            animation: navShow 0.3s;
            border-bottom: 1px solid #eeeeee;
        }
        .tagsBox{
            margin-top: 0.1rem;
            .orderFunc-tips{
                width: auto;
                padding: 0 0.1rem;
                height: 0.17rem;
                border-radius: 3px;
                background: #FFDD71;
                font-size: 0.12rem;
                color: #FA8801;
                margin-right: 0.1rem;
                line-height: 0.18rem;
            }
            .orderFunc-tipsn{
                color: #999999;
                background: #DBDBDB;
            }
            .orderFunc-btn{
                width: 0.7rem;
                height: 0.24rem;
                line-height: 0.24rem;
                font-size: 0.14rem;
                color: white;
                background-size: 100% 100%;
                background-repeat: no-repeat;
            }
        }
        
    }
    .Receipts{
        width: 100%;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
    }
    .Receipts-close{
        position: absolute;
        width: 0.24rem;
        height: 0.24rem;
        top: 0.05rem;
        right: 0.05rem;
    }
    .Receipt-box{
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        padding: 0.2rem 0.12rem;
        background: white;
        .Receipt-msg{
            flex-direction: column;
            line-height: 0.24rem;
            margin: 0.1rem 0;
            P{
                span{
                    display: block;
                    max-width: 50%;
                }
            }
        }
        table{
            width: 100%;
            margin-bottom: 0.1rem;
            tr{
                line-height: 0.3rem;
            }
        }
    }
    .Confirmation-tips{
        flex-direction: column;
        text-align: left;
        color: #999;
        padding: 0 0.16rem 0.16rem;
        font-size: 0.12rem;
        line-height: 0.18rem;
        width: 100%;
        word-wrap: break-word;
        word-break: break-all;
    }
    .textcopy{
        background: #eee;
        color: #999999;
        width: 0.2rem!important;
        height: 0.2rem!important;
        line-height: 0.2rem;
        font-style: normal;
        font-size: 0.12rem;
        padding: 0.01rem 0.05rem;
        border-radius: 0.03rem;
        margin-left: 0.1rem;
        text-align: center;
    }
  }
</style> 

